// extracted by mini-css-extract-plugin
export default {"content":"Inventory_content__c5x4T","cards":"Inventory_cards__ZL8VQ"};